(function () {
  function syncArrowTop(gutter) {
    if (!gutter.querySelector('.featured-collection__slider-buttons')) return;
    const media = gutter.querySelector('.product-grid .grid__item .card__media');
    if (!media) return;
    const g = gutter.getBoundingClientRect();
    const m = media.getBoundingClientRect();
    const centerPx = m.top + m.height * 0.5 - g.top;
    const next = `${Math.round(centerPx)}px`;
    if (gutter.style.getPropertyValue('--fc-arrow-top').trim() !== next) {
      gutter.style.setProperty('--fc-arrow-top', next);
    }
  }

  function bind(gutter) {
    if (gutter.dataset.fcArrowAlignBound) return;
    gutter.dataset.fcArrowAlignBound = 'true';
    const run = function () {
      syncArrowTop(gutter);
    };
    run();
    const ro = new ResizeObserver(run);
    ro.observe(gutter);
    const slide = gutter.querySelector('.product-grid .grid__item');
    if (slide) ro.observe(slide);
    const media = gutter.querySelector('.product-grid .grid__item .card__media');
    if (media) ro.observe(media);
  }

  function initWithin(container) {
    const sections = container.classList?.contains('section-featured-collection')
      ? [container]
      : Array.from(container.querySelectorAll('.section-featured-collection'));
    for (let i = 0; i < sections.length; i++) {
      const gutter = sections[i].querySelector('.slider-mobile-gutter');
      if (gutter) bind(gutter);
    }
  }

  function onReady() {
    initWithin(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.classList?.contains('section-featured-collection')) {
      initWithin(event.target);
    }
  });
})();
